import React, {useState} from "react";
import EstacionamientoHeader from "./EstacionamientoHeader";
import "bootstrap/dist/css/bootstrap.min.css";

import { useNavigate, NavLink, Navigate } from "react-router-dom";
import EstacionamientoSmallHeader from "./EstacionamientoSmallHeader";



const EstacionamientoFin = () => {
    const navigate = useNavigate();
    

    

    return (
        <>
       <div class="container text-center estacionamientoContent" >
       <EstacionamientoSmallHeader texto="" retorno="/estacionamiento"/>
       <div class="row">
                <div class="col">
                <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/estacionamiento")}}/>
                        <img src="./estacionamient-fin-1.png"  class="imgSubtitleMain" ></img>
                   
                </div>
        </div>
       <div class="row">
            <div class="col">
                <h1>¡Estacionamiento finalizado con &eacute;xito!</h1>
            </div>
        </div>
        <div class="row">
        <div class="col">
                <h1 class="dataIndicator">Patente: {localStorage.getItem("estacionamiento_patente")} <br/> Lugar: {localStorage.getItem("estacionamiento_lugar")}</h1>
            </div>
        </div>
        <div class="row">
        <div class="col">
                <h4>Tiempo transcurrido {localStorage.getItem("estacionamiento_duracion")}</h4>
            </div>
        </div>
        <div class="row">
               
                <div class="col">
                    
                    
                    <div className="buttonContainer">
                        <button className="buttonDanger" onClick={() => navigate("/estacionamiento")}>Total <b> ${localStorage.getItem("estacionamiento_costo")}</b></button>
                    </div>
                </div>
            </div>
           
        </div>
        
        
        
        </>

    );
    }
export default EstacionamientoFin;